import type { GetStaticProps } from "next"
import {
  getFeedArchive,
  type TeaserArchiveProps,
} from "@/components/resources/data/archives"
import { SiteLayout } from "@/components/resources/layouts/site"
import { CategoryArchive } from "@/components/resources/templates/CategoryArchive"

const Resources = (props: TeaserArchiveProps) => <CategoryArchive {...props} />

Resources.getLayout = SiteLayout

export default Resources

export const getStaticProps: GetStaticProps<TeaserArchiveProps> = async () => {
  const props = await getFeedArchive(1)
  return props ? { props, revalidate: 180 } : { notFound: true }
}
